import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ContentPage as ContentPageModel } from '../../../@types/ContentPage';
import { get } from '../../../actions/contentpage';
import { asHtml } from '../../../helpers/markdown';
import { createPageTitle } from '../../../helpers/text';
import useTrackPageView from '../../../hooks/useTrackPageView';
import type { RootState } from '../../../reducers';
import { getContentPage } from '../../../selectors/content-page';
import Loader from '../../../styled-components/components/Loader';
import { resetViewport } from '../../../utils/ts/viewport';
import LeftNavigation from './left-navigation';

interface ContentPageProps {
  slug: string;
}

const ContentPage = ({ slug }: ContentPageProps) => {
  const dispatch = useDispatch();
  const page = useSelector<RootState, ContentPageModel | null | undefined>((s) =>
    getContentPage(s, slug),
  );
  const actions = bindActionCreators({ getContentPage: get }, dispatch);
  const trackPageViewEvent = useTrackPageView();

  useEffect(() => {
    resetViewport();
  }, []);

  useEffect(() => {
    if (!page) {
      actions.getContentPage(slug);
    } else {
      document.title = createPageTitle(page.title);
      trackPageViewEvent();
    }
  }, [page]);

  if (!page) {
    return <Loader />;
  }

  const { title, content, bottomContent, featuredMedia, disableNavigation } = page;
  return (
    <div className="container m-b-triple">
      <div className="m-b-double hidden-lt-md" />
      <div className="row">
        {!disableNavigation && (
          <div className="col-md-3 m-b">
            <LeftNavigation />
          </div>
        )}
        <div className={disableNavigation ? 'col-md-8 col-md-offset-2' : 'col-md-9'}>
          <div data-am-content="limit-width font-weight-regular">
            <h1>{title}</h1>
            {featuredMedia && <img aria-label="featuerd media" src={featuredMedia.file.url} />}
            {content && <div dangerouslySetInnerHTML={{ __html: asHtml(content) }} />}
            {bottomContent && <div dangerouslySetInnerHTML={{ __html: asHtml(bottomContent) }} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentPage;
